<template>
  <v-col cols="auto" class="pa-0 pb-5">
    <v-row no-gutters align="center" class="pb-4">
      <v-radio-group
        class="my-0 py-0 input--type"
        v-model="type"
        @change="clear"
        :disabled="searching"
        dense
        row
        hide-details
      >
        <v-radio :label="$i18n.t('sidebar.nodes')" value="nodes" class="mr-8"></v-radio>
        <v-radio :label="$i18n.t('sidebar.links')" value="links"></v-radio>
      </v-radio-group>
    </v-row>
    <v-row no-gutters align="center">
      <v-col :cols="textInputCols">
        <v-menu
          :attach="true"
          v-model="isMenuVisible"
          nudge-bottom="25"
          :close-on-content-click="false"
          :close-on-click="false"
          :open-on-click="false"
        >
          <template #activator="{ on }">
            <data-input
              v-on="on"
              v-bind="searchItem"
              v-model="searchText"
              class="modeling-results-search-input"
              @focus="onFocus"
              @input="search"
            />
          </template>
          <v-list
            v-if="results.length > 0"
            class="modeling-results-search-list"
            v-click-outside="{
              handler: onClickOutside,
              include,
              closeConditional,
            }"
            dense
          >
            <v-list-item
              v-for="(result, idx) in results"
              :key="idx"
              class="modeling-result-search-element"
              @click="goToResult(result)"
            >
              <v-list-item-content>
                <v-list-item-title class="text-body-2 modeling-result-search-element-text">
                  {{ result.label }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>
  </v-col>
</template>
<script>
import { call } from 'vuex-pathify';
import { debounce } from 'lodash';
import DataInput from '@/components/DataInput';

export default {
  name: 'ModelingResultsSearch',
  components: {
    DataInput,
  },
  props: {
    netType: {
      type: String,
      required: true,
    },
    scenarioId: {
      type: [Number, String],
      required: true,
    },
    textInputCols: {
      type: [Number, String],
      default: 9,
    },
  },
  computed: {
    isMenuVisible: {
      get() {
        return this.isResultListVisible && this.results.length > 0;
      },
      set(nV) {
        this.isResultListVisible = nV;
      },
    },
    searchItem() {
      return {
        dataType: {
          name: 'text',
        },
        appendIcon: 'mdi-magnify',
        clearable: true,
        dense: true,
        height: '20',
        hideDetails: true,
        label: this.$i18n.t('sidebar.searchByLabelValue'),
        loading: this.searching,
      };
    },
  },
  data: () => ({
    isResultListVisible: false,
    results: [],
    searchText: '',
    searching: false,
    type: 'nodes',
  }),
  methods: {
    searchModelingResults: call('search/searchModelingResults'),
    clear() {
      this.results = [];
      this.searchText = '';
    },
    closeConditional() {
      return this.isResultListVisible;
    },
    include() {
      return [document.querySelector('.modeling-results-search-input')];
    },
    onClickOutside() {
      this.isResultListVisible = false;
    },
    onFocus() {
      this.isResultListVisible = true;
    },
    goToResult(result) {
      this.isResultListVisible = false;
      this.$root.$emit('createGeomAndFitView', result.geometry);
      this.$router.push({
        name: 'modelingResultsFeature',
        params: {
          type: this.type,
          scenarioId: this.scenarioId,
          elementId: result.id,
        },
      });
    },
    async search() {
      this.searching = true;
      if (!this.searchText) {
        this.results = [];
        this.searching = false;
        return;
      }
      const payload = {
        params: {
          limit: 20,
          search_text: this.searchText,
        },
        netType: this.netType,
        scenarioId: this.scenarioId,
        objectType: this.type,
      };
      try {
        const results = await this.searchModelingResults(payload);
        this.results = results;
        this.searching = false;
      } catch {
        this.results = [];
        this.searching = false;
      }
    },
  },
  created() {
    this.search = debounce(this.search, 500);
  },
};
</script>
<style lang="scss" scoped>
.modeling-results-search-list {
  max-height: 300px;
  overflow-y: auto;
}
.modeling-result-search-element {
  text-align: left;
  min-height: 36px;
  max-height: 36px;
}
.modeling-result-search-element:hover {
  background-color: rgba(188, 188, 188, 0.2);
}
.modeling-result-search-element-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: normal !important;
}
::v-deep {
  .input--type {
    .v-icon {
      font-size: 15px;
    }
    .v-label {
      font-size: 12px;
    }
    .v-input--selection-controls__ripple {
      width: 15px;
      height: 15px;
      left: -3px;
      top: calc(50% - 15px) !important;
    }
    .v-input--selection-controls__input {
      margin-right: 0;
    }
  }
  .modeling-results-search-input {
    .v-label {
      font-size: 12px;
    }
  }
}
</style>
